export default __webpack_public_path__ + "static/media/form.4bed2541.svg";